import { render, staticRenderFns } from "./AvatarPlaceholder.vue?vue&type=template&id=a9fe24ea"
import script from "./AvatarPlaceholder.vue?vue&type=script&setup=true&lang=ts"
export * from "./AvatarPlaceholder.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports